// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wc-_","left":"styles_left__24x8v"};